
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { fundmanagerapi } from "../../ApiNames";

export const fetchdatasuccess = (data: any) => ({
    type: 'fetch_data_success',
    payload: data
})
export const fetchadddatasuccess = (dataview: any) => ({
    type: 'fetch_data_Add_success',
    payload: dataview
})

export const fetchdata = (uid: any, nameId: any) => {
    return async (dispatch: Dispatch) => {
        try {
            let q = 0;
            if (nameId === 'donor') {
                q = 1;
            } else if (nameId === 'organization') {
                q = 2;
            }
            const payload = { type: nameId, uid: uid, q: q };
            const apiname = '/ws_an_feedbackdetails.php';
            const response = await LoginService.getData(apiname, payload);
            dispatch(fetchdatasuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const addfeed = (uid: any,feedbacktype:any,description:any,nameId:any,id:any) => {
    return async (dispatch: Dispatch) => {      
        try {
            const payload = { uid: uid,feedbacktype:feedbacktype,description:description,type:nameId ,id:id };
            const apiname = fundmanagerapi.adddata;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchadddatasuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
}


